export default "__VITE_ASSET__DmL9CKIa__"